<template>
  <b-table
    class="profiles-table"
    :data="profileValues"
    :checkable="false"
    backend-sorting
    :default-sort="[sortField, sortDirection]"
    @sort="onSort">
    <template slot-scope="props">
      <template v-for="item in props.row">
        <b-table-column
          v-if="columns.includes(item.label)"
          :key="item.label"
          :field="item.field"
          :label="item.label"
          :sortable="sortableFields.includes(item.field)"
          :centered="item.centered">
          <router-link v-if="item.link" :to="item.link">
            {{ item.value }}
          </router-link>
          <span v-else>{{ item.value }}</span>
        </b-table-column>
      </template>
    </template>
  </b-table>
</template>

<script>
import _ from 'lodash';
import profiles from '@/mixins/profiles';

export default {
  name: 'ProfileTable',
  mixins: [profiles],
  props: {
    profiles: {
      type: Array,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    sortDirection: {
      type: String,
      required: true,
    },
    onSort: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        'Name',
        'Analytics',
        'Sync Interval',
        'Auto Update',
        'Actions Config',
        'Created',
        'Modified',
      ],
      sortableFields: [
        'name',
        'autoUpdate',
        'infoSyncInterval',
        'created',
        'updated',
        'actionConfigsId',
      ],
    };
  },
  computed: {
    profileValues() {
      return _.map(this.profiles, p => this.keyValues(p));
    },
  },
};
</script>

<style lang="scss" scoped>

div.profiles-table {
  th.date, td.date {
    width: $table-date-width;
  }
}

</style>
